module.exports = __webpack_public_path__ + "static/media/Order-Icon.64d909e7.svg";